export default __webpack_public_path__ + "static/media/garage9.06fa42fd.jpg";